import React, { Fragment, useContext } from "react";

import FormGrid from "../../forms/FormGrid";
import { Instructions } from "./components";
import { LoginContext } from "./LoginContainer";
import RadioGroup from "../../inputs/RadioGroup";

const getFields = scopes => {
  return {
    groups: [
      {
        items: [
          {
            input: {
              name: "scopeId",
              InputComponent: RadioGroup,
              label: "",
              options: scopes.map(({ id, name }) => ({
                label: name,
                value: id,
              })),
            },
            grid: { xs: 12 },
          },
        ],
      },
    ],
  };
};

export const SelectScopeCard = ({ formikProps }) => {
  const { scopes } = useContext(LoginContext);
  const { values, errors } = formikProps;

  const fields = getFields(scopes);

  return (
    <Fragment>
      <Instructions>
        Please select the scope associated with your account.
      </Instructions>
      <FormGrid
        fields={fields}
        values={values}
        errors={errors}
        {...formikProps}
      />
    </Fragment>
  );
};
